// OutcomeNode.reasonListFrom resolution. Generic — reads a string[] of
// already-formatted reason labels from the engine's context values. The
// grouping is decided by the pathway layer before it is written to context.

import type { OutcomeNode } from "../../types/pathway.types";

export function resolveOutcomeReasonList(
  node: OutcomeNode | undefined,
  contextValues: Record<string, unknown>,
): string[] | undefined {
  const key = node?.reasonListFrom;
  if (!key) return undefined;
  const value = contextValues[key];
  if (!Array.isArray(value)) return undefined;
  return value.filter((item): item is string => typeof item === "string");
}
